/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function BillingInvoiceDiscountFromJSON(json) {
    return BillingInvoiceDiscountFromJSONTyped(json, false);
}
export function BillingInvoiceDiscountFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        amount: json['amount'],
        couponName: json['coupon_name']
    };
}
export function BillingInvoiceDiscountToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        amount: value.amount,
        coupon_name: value.couponName
    };
}
